import { namespace } from 'vuex-class';
import type { BindingHelpers } from 'vuex-class/lib/bindings';
import type { SessionState } from './session.types';

export const sessionNamespace = 'session';
export const Session: BindingHelpers = namespace(sessionNamespace);

export function getDefaultState(): SessionState {
  return {
    token: { jwt: '', exp: null },
    authentication: {
      submittingResponse: false,
      steps: [],
      answers: [],
    },
    status: null,
    error: false,
    isCorrectPin: null,
    sendPinRetryCount: 0,
    recipientFirstOpen: false,
  };
}
